import { graphql } from 'relay-runtime';

export const AUTHENTICATE_TRANSACTION_MUTATION = graphql`
  mutation AuthenticateTransactionMutation($token: String!) {
    unified {
      linking {
        authenticateLinkingWithLoggedInAccount(token: $token) {
          ... on UnifiedLinkAuthenticationPayload {
            id
            account2 {
              aaid
              emailId
            }
            account1 {
              aaid
              emailId
            }
            token
            primaryAccountIndex
          }
          ... on UnifiedLinkingStatusPayload {
            message
            success
            errors {
              extensions {
                errorType
                statusCode
              }
              code
              message
            }
          }
        }
      }
    }
  }
`;
